import { UpgradeButton } from "@components/plan-subscription-lock";
import { VersionTableRowSkeleton } from "./version-table-row-skeleton";

export const VersionsTableProLock = () => {
  return (
    <div className="tw-relative">
      <div className="tw-opacity-80">
        {Array.from({ length: 7 }).map((_, index) => (
          <VersionTableRowSkeleton key={`skeleton-${index}`} skipLoading />
        ))}
      </div>
      <div
        style={{
          background:
            "linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #FFF 100%)",
        }}
        className="tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center"
      >
        <div className="tw-flex tw-flex-col tw-items-center">
          <p className="tw-font-sans tw-text-sm tw-font-semibold tw-text-blue tw-text-center">
            Get more insights with Storydoc Pro
          </p>
          <p className="tw-font-sans tw-text-xs tw-font-normal tw-text-blue-500 tw-text-center tw-mt-2">
            Upgrade to Storydoc Pro to get more insights.
          </p>
          <UpgradeButton
            plan="pro"
            feature="versions-table"
            className="tw-mt-4"
            size="sm"
          />
        </div>
      </div>
    </div>
  );
};
